export const SET_NOTIFY = "SET_NOTIFY";
export const CLOSE_NOTIFY = "CLOSE_NOTIFY";
